import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import { getEntityEndpoint } from '@/shared/api/openmetadata';
import type { JsonPatchOperation } from '@/shared/types/common';

export const updateAssetDescription = async (
  entityType: string,
  entityId: string,
  operations: JsonPatchOperation[]
): Promise<void> => {
  const endpoint = getEntityEndpoint(entityType);
  await openMetadataApiClient.patch(`/${endpoint}/${entityId}`, operations, {
    headers: {
      'Content-Type': 'application/json-patch+json',
    },
  });
};
